import {Checkbox} from '@wandb/components';
import React from 'react';

import {useRunSelectorFeatureDisabled} from '../RunSelectorFeaturesContext';

type RowSelectionProps = {
  checkboxState: 'unknown' | 'checked' | 'unchecked' | 'partial';
  isGroup: boolean;
  isTableCollapsed: boolean;
  onPress?: () => void;
};

export function RowSelection({
  checkboxState,
  isGroup,
  isTableCollapsed,
  onPress,
}: RowSelectionProps) {
  const isDisabled = useRunSelectorFeatureDisabled();

  const isCheckboxDisabled =
    isDisabled('tag') && isDisabled('move') && isDisabled('delete');

  if (isCheckboxDisabled || isTableCollapsed) {
    return null;
  }

  return (
    <Checkbox
      aria-label={isGroup ? 'Select group' : 'Select run'}
      data-test="select-run-checkbox"
      isSelected={checkboxState === 'checked'}
      isIndeterminate={checkboxState === 'partial'}
      onPress={onPress}
    />
  );
}
